var _style, _g, _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDiversityLogoMitRahmen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6D558C;}\n\t.st1{fill:#499EBF;}\n\t.st2{fill:#48B59B;}\n\t.st3{fill:#B61F40;}\n\t.st4{fill:#D1B37C;}\n\t.st5{clip-path:url(#SVGID_2_);fill:none;stroke:#B61E3F;stroke-width:0.8927;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.9,44.1c2.4,0,4.4-2,4.4-4.6s-2-4.6-4.4-4.6c-2.4,0-4.4,2-4.4,4.6C66.4,42,68.4,44.1,70.9,44.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,94.5c-2-1.5-4.8-1-6.2,1.1c-1.4,2.1-0.9,4.9,1.1,6.4c2,1.5,4.8,1,6.2-1.1C57.8,98.8,57.3,95.9,55.3,94.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.1,63.7c0.6-2.4-0.8-4.9-3.1-5.6c-2.4-0.7-4.8,0.8-5.4,3.2c-0.6,2.4,0.8,4.9,3.1,5.6 C42.1,67.6,44.5,66.1,45.1,63.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.9,63.5c0.8,2.4,3.4,3.6,5.7,2.7s3.5-3.5,2.7-5.9c-0.8-2.4-3.4-3.6-5.7-2.7C97.2,58.5,96,61.1,96.9,63.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67,49.8c0.1,0.1,0.3,0.1,0.4,0.1l-3.4,9.8c2-1.2,4.3-1.9,6.8-1.9c2.6,0,5,0.7,7.1,2l-3.6-10.2l9.3-4.1 c0,0,1.2-0.5,0.7-1.8l-0.1-0.4c0,0-0.5-1.3-1.7-0.7l-9.1,4c-0.2-0.5-0.8-1.6-2.5-1.6C69,45.3,68.5,47,68.5,47l0,0.1 C68.3,47,68.2,47,68.2,47l-9.5-4.2c-1.2-0.5-1.7,0.7-1.7,0.7l-0.1,0.4c-0.5,1.3,0.7,1.8,0.7,1.8L67,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.1,74.3l-6.8-7.5c0.4-0.4,1.2-1.4,0.6-3c-0.7-1.8-2.4-1.7-2.4-1.7h-0.1c0-0.2,0-0.3,0-0.3l0.5-10.7 c0.1-1.4-1.3-1.4-1.3-1.4l-0.4,0c-1.3-0.1-1.4,1.3-1.4,1.3l-0.5,10.7c0,0.2,0,0.3,0,0.5l-9.6,0.1c2.4,2.6,3.9,6,3.9,9.9 c0,1.6-0.2,3-0.7,4.4l9-7.7l6.9,7.6c0,0,0.9,1,1.9,0.1l0.3-0.3C102,76.3,103,75.3,102.1,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.4,95.5c-1.4-2.1-4.2-2.6-6.2-1.1s-2.5,4.3-1.1,6.4c1.4,2.1,4.2,2.6,6.2,1.1 C94.3,100.4,94.8,97.6,93.4,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.6,92.1c-0.1-0.1-0.2-0.3-0.3-0.4l7.6-5.5c-4.9-0.7-8.9-4.1-10.7-8.6l-2.7,10.3l-9.9-2.2c0,0-1.3-0.3-1.6,1 L44,87.1c0,0-0.3,1.3,1,1.6l9.7,2.1c-0.1,0.5-0.2,1.8,1.2,2.8c1.6,1.1,2.9,0,2.9,0l0.1,0c0.1,0.1,0.1,0.2,0.1,0.2l5.5,9 c0.7,1.2,1.8,0.4,1.8,0.4l0.3-0.2c1.1-0.7,0.4-1.9,0.4-1.9L61.6,92.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.2,72.1c0-4.8,2.3-9,5.8-11.6l-11.7,1l-1.4-10.3c0,0-0.2-1.4-1.5-1.2L48,50.2c0,0-1.3,0.2-1.1,1.5l1.4,10.1 c-0.5,0.1-1.7,0.4-2.1,2.1c-0.4,1.9,1.1,2.8,1.1,2.8l0.1,0c-0.1,0.1-0.2,0.2-0.2,0.2l-6.4,8.4c-0.8,1.1,0.2,1.9,0.2,1.9l0.3,0.2 c1,0.8,1.9-0.2,1.9-0.2l6.4-8.4c0.1-0.1,0.2-0.3,0.2-0.4l7.6,5.4C57.2,73.4,57.2,72.8,57.2,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.9,86.7l-0.1-0.4c-0.3-1.3-1.6-1-1.6-1l-10.1,2.2c-0.2,0-0.3,0.1-0.4,0.1l-2.9-10.7 c-1.6,4.8-5.7,8.4-10.7,9.2l8,5.8l-5.4,8.8c0,0-0.7,1.2,0.4,1.9l0.3,0.2c0,0,1.1,0.7,1.8-0.4l5.3-8.7c0.4,0.3,1.6,0.8,2.9-0.2 c1.5-1.2,1-2.9,1-2.9l0-0.1c0.2,0,0.3,0,0.3,0l10.1-2.2C99.2,88,98.9,86.7,98.9,86.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 8.2,
    y: 9.7,
    width: 125.4,
    height: 125.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 28.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -30.4472 71.3846)",
    className: "st5",
    width: 87.8,
    height: 87.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiversityLogoMitRahmen);
export default __webpack_public_path__ + "static/media/icon-diversity-logo-mit-rahmen.dacd43ac5efcf9a7f772a7b685b1cfe5.svg";
export { ForwardRef as ReactComponent };